import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AppContext } from '../../context/AppContext';
import { ProductCard, ProgressBar, Layout } from '../../components';
import { Button, Headline, Richtext } from '../../elements';
import { OVERVIEW, PRODUCTS } from '../../navigation/routes';
import styles from './ProductsPage.module.scss';
import {
	checkMediaNetwork,
	checkAdScreenAndSmartMirror,
	checkFullHeight,
	checkHalfHeight,
} from '../../helper/conditions';
import { UPDATE_ELEVATOR_DATA, SET_MODE } from '../../context/ActionTypes';

import imgMediaScreen from '../../assets/images/products/media-screen.jpg';
import imgMediaScreen_low from '../../assets/images/products/media-screen_low.jpg';

import imgAdScreenFull from '../../assets/images/products/ad-screen-full.jpg';
import imgAdScreenFull_low from '../../assets/images/products/ad-screen-full_low.jpg';
import imgAdScreenHalf from '../../assets/images/products/ad-screen-half.jpg';
import imgAdScreenHalf_low from '../../assets/images/products/ad-screen-half_low.jpg';

import imgSmartMirrorFull from '../../assets/images/products/smart-mirror-full.jpg';
import imgSmartMirrorFull_low from '../../assets/images/products/smart-mirror-full_low.jpg';
import imgSmartMirrorHalf from '../../assets/images/products/smart-mirror-half.jpg';
import imgSmartMirrorHalf_low from '../../assets/images/products/smart-mirror-half_low.jpg';

import imgSchindlerMediaNetwork from '../../assets/images/products/schindler-media-network.jpg';
import imgSchindlerMediaNetwork_low from '../../assets/images/products/schindler-media-network_low.jpg';

import imgIndividualAdvice from '../../assets/images/hero.jpg';
import imgIndividualAdvice_low from '../../assets/images/hero_low.jpg';

const ProductsPage = () => {
	const { state, dispatch } = React.useContext(AppContext);
	const navigate = useNavigate();
	const { id } = useParams();
	const { buildingType } = state.configuration;
	const { class_cabine, glass_interieur, throughloader, depth_of_cabin, width_of_cabin, height_of_cabin, width_of_cabin_door, height_of_cabin_door, floors } =
		state.configuration.elevators[state.elevatorIndex];

	const isMediaNetwork = checkMediaNetwork(state.lead.zip, floors, buildingType);
	const isAdScreenAndSmartMirror = checkAdScreenAndSmartMirror(
		class_cabine,
		glass_interieur,
		throughloader,
		depth_of_cabin,
		width_of_cabin,
	);
	const isFullHeight = checkFullHeight(width_of_cabin, height_of_cabin, width_of_cabin_door, height_of_cabin_door);
	const isHalfHeight = checkHalfHeight(width_of_cabin, height_of_cabin, width_of_cabin_door, height_of_cabin_door);

	const handleClickIndividualAdvice = () => {
		const product = {
			name: 'Individuelle Beratung',
			size: '',
		}
		dispatch({
			type: UPDATE_ELEVATOR_DATA,
			payload: { product },
		});
		dispatch({ type: SET_MODE, payload: 'completed' });

		navigate(OVERVIEW);
	}

	return (
		<Layout>
			<ProgressBar />
			<Headline variant='h2'>Digitale Lösungen</Headline>

			<Richtext>
				<p>Wählen Sie eines der nachfolgenden Produkte für Ihren Aufzug.</p>
			</Richtext>

			<section>
				{isAdScreenAndSmartMirror && (
					<React.Fragment>
						{isFullHeight && (
							<ProductCard
								image={imgAdScreenFull}
								imagePlaceholder={imgAdScreenFull_low}
								productName='AdScreen Full Height'
								link={`${PRODUCTS}/${id ? id : 'add'}/adscreen-full-height`}
							/>
						)}

						{isHalfHeight && (
							<ProductCard
								image={imgAdScreenHalf}
								imagePlaceholder={imgAdScreenHalf_low}
								productName='AdScreen Half Height'
								link={`${PRODUCTS}/${id ? id : 'add'}/adscreen-half-height`}
							/>
						)}

						{isFullHeight && (
							<ProductCard
								image={imgSmartMirrorFull}
								imagePlaceholder={imgSmartMirrorFull_low}
								productName='SmartMirror Full Height'
								link={`${PRODUCTS}/${id ? id : 'add'}/smartmirror-full-height`}
							/>
						)}

						{isHalfHeight && (
							<ProductCard
								image={imgSmartMirrorHalf}
								imagePlaceholder={imgSmartMirrorHalf_low}
								productName='SmartMirror Half Height'
								link={`${PRODUCTS}/${id ? id : 'add'}/smartmirror-half-height`}
							/>
						)}
					</React.Fragment>
				)}

				{isMediaNetwork && (
					<ProductCard
						image={imgSchindlerMediaNetwork}
						imagePlaceholder={imgSchindlerMediaNetwork_low}
						productName='Schindler Media Network'
						link={`${PRODUCTS}/${id ? id : 'add'}/schindlermedianetwork`}
					/>
				)}

				<ProductCard
					image={imgMediaScreen}
					imagePlaceholder={imgMediaScreen_low}
					productName='MediaScreen'
					link={`${PRODUCTS}/${id ? id : 'add'}/mediascreen`}
				/>

				{!isAdScreenAndSmartMirror && (
					<ProductCard
						image={imgIndividualAdvice}
						imagePlaceholder={imgIndividualAdvice_low}
						productName='Individuelle Beratung'
						description={`Auch bei nicht standardisierten Kabinenmaßen können wir Ihnen ggf. eine maßgeschneiderte Lösung
										anbieten. Lassen Sie sich unverbindlich beraten.`}
						onClick={() => handleClickIndividualAdvice()}
					/>
				)}
			</section>

			<div className={styles.footer}>
				<Button type='button' title='Zurück' variant='outline' onClick={() => navigate(-1)} />
			</div>
		</Layout>
	);
};

export default ProductsPage;
